import { IAccommodationRoomTypeParams } from "Bands/types";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IAPIError, IDataKeys, IJSONAPIItem } from "shared/types";

interface IJSONAPIAccommodationRoomType {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIAccommodationRoomTypeCollection {
  [IDataKeys.eventAccommodationRoomType]: IJSONAPIAccommodationRoomType;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class EventAccommodationRoomTypeService {
  static deleteAccommodationRoomType = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_ROOM_TYPE(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_EVENT_ACCOMMODATION_ROOM_TYPE);
        return reject(error);
      }
    });

  static createAccommodationRoomType = (
    data: IAccommodationRoomTypeParams
  ): Promise<IJSONAPIAccommodationRoomTypeCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_ROOM_TYPES,
          data,
        });

        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.CREATE_EVENT_ACCOMMODATION_ROOM);
        return reject(error);
      }
    });

  static getEventAccommodationRoomTypes = (
    blockId: string
  ): Promise<IJSONAPIAccommodationRoomTypeCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.get({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_ROOM_TYPES_FOR_BLOCK(blockId),
        });

        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_EVENT_ACCOMMODATION_ROOM_TYPES);
        return reject(error);
      }
    });

  static editAccommodationRoomType = ({
    id,
    data,
  }: {
    id: string;
    data: IAccommodationRoomTypeParams;
  }): Promise<IJSONAPIAccommodationRoomType> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.patch({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_ROOM_TYPE(id),
          data,
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_EVENT_ACCOMMODATION_ROOM_TYPE);
        return reject(error);
      }
    });
}
